"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import styled from "styled-components";
const SVG = styled.svg`
  min-width: ${({ $size }) => $size};
  max-width: ${({ $size }) => $size};
  height: ${({ $size }) => $size};
`;
const Link = ({ size = "1em", color = "currentColor", title, ...props }) => /* @__PURE__ */ jsxs(SVG, { ...props, $size: size, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", role: title ? "img" : "presentation", children: [
  title ? /* @__PURE__ */ jsx("title", { children: title }) : null,
  " ",
  /* @__PURE__ */ jsx("path", { fill: color, d: "M14.521 5.306a2.754 2.754 0 0 1 3.891-.002 2.75 2.75 0 0 1 0 3.89l-3.242 3.24a2.75 2.75 0 0 1-3.89.002.75.75 0 0 0-1.06 1.06 4.25 4.25 0 0 0 6.01 0l3.242-3.242a4.25 4.25 0 0 0 0-6.01 4.254 4.254 0 0 0-6.012.001l-2.18 2.18a.75.75 0 0 0 1.061 1.06l2.18-2.18zm-5.325 13.13a2.754 2.754 0 0 1-3.89.001 2.75 2.75 0 0 1 0-3.89l3.241-3.24a2.75 2.75 0 0 1 3.89-.001.75.75 0 0 0 1.06-1.061 4.25 4.25 0 0 0-6.01 0l-3.242 3.242a4.25 4.25 0 0 0 0 6.011 4.254 4.254 0 0 0 6.012-.002l2.18-2.18a.75.75 0 0 0-1.06-1.06l-2.18 2.18z", children: " " })
] });
var Link_default = Link;
export {
  Link_default as default
};
